$(function() {

    ele.region = {
        ENGLAND: 1,
        WALES: 2,
        SCOTLAND: 3,
        NI: 4
    };

    /* not the fastest way when it comes to search but easiest to organise/maintain list */
    ele.county = {
        list: {
            1: ["Bedfordshire","Berkshire","Bristol","Buckinghamshire","Cambridgeshire","Cheshire","Cornwall","Cumbria","Derbyshire","Devon","Dorset","Durham","East Riding of Yorkshire","East Sussex","Essex","Gloucestershire","Greater Manchester","Hampshire","Hereford and Worcester","Hertfordshire","Isle of Man","Isle of Wight","Kent","Lancashire","Leicestershire","Lincolnshire","London","Merseyside","Middlesex","Norfolk","North Yorkshire","Northamptonshire","Northumberland","Nottinghamshire","Oxfordshire","Rutland","Shropshire","Somerset","South Yorkshire","Staffordshire","Suffolk","Surrey","Tyne and Wear","Warwickshire","West Midlands","West Sussex","West Yorkshire","Wiltshire"],
            2: ["Anglesey/Sir Fon","Blaenau Gwent","Bridgend","Caerphilly","Cardiff","Carmarthenshire","Ceredigion","Conwy","Denbighshire","Flintshire","Glamorgan","Gwynedd","Merthyr Tydfil","Monmouthshire","Neath Port Talbot","Newport","Pembrokeshire","Powys","Rhondda Cynon Taff","Swansea","Torfaen","Wrexham"],
        3: ["Aberdeenshire","Angus","Argyll and Bute","Ayrshire","Clackmannanshire","Dumfries and Galloway","Dunbartonshire","Dundee","East Lothian","Edinburgh","Falkirk","Fife","Glasgow","Highland","Inverclyde","Lanarkshire","Midlothian","Moray","Orkney","Perth and Kinross","Renfrewshire","Scottish Borders","Shetland Isles","Stirlingshire","West Lothian","Western Isles"],
        4: ["County Antrim", "County Armagh", "County Down", "County Fermanagh", "County Londonderry", "County Tyrone", "Co. Antrim", "Co. Armagh", "Co. Down", "Co. Fermanagh", "Co. Londonderry", "Co. Tyrone"]
},

        /* returns region enum from ele.region on success. 0 on failure */
        findRegionFromCounty: function(county = "") {
            for (const c in ele.county.list) {
                if (ele.county.list[c].indexOf(county) > -1) {
                    return parseInt(c);
                }
            }
            return 0;
        }

    };

});